/**
 * Telemedicine · Phase 1 · Lobby — generic close (X) icon.
 *
 * 17×17 SVG that matches the Figma stroke (2px, rounded caps). Lives outside
 * `Ionicons` so the visual is exactly the design — Ionicons' `close` glyph is
 * a different stroke ratio and the small size makes the discrepancy visible.
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface CloseIconProps {
  size?: number;
  color?: string;
}

export default function CloseIcon({ size = 17, color = '#151515' }: CloseIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 17 17" fill="none">
      <Path
        d="M4.24219 12.728L12.7275 4.24268"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.24219 4.24261L12.7275 12.7279"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
